// extracted by mini-css-extract-plugin
module.exports = {"borderNone":"showcase_borderNone__yAOys"};